<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Field of interest' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Name' | translate}} *</label>
      <input class="form-control" [(ngModel)]="entity.name" />
    </div>

    <div class="form-group">
      <label>{{'Name' | translate}} BE</label>
      <input class="form-control" [(ngModel)]="entity.nameBe" />
    </div>

    <div class="form-group">
      <label>{{'Name' | translate}} EN</label>
      <input class="form-control" [(ngModel)]="entity.nameEn" />
    </div>

    <div class="form-group">
      <label>{{'Name' | translate}} DE</label>
      <input class="form-control" [(ngModel)]="entity.nameDe" />
    </div>

    <div class="form-group">
      <label>{{'Name' | translate}} FR</label>
      <input class="form-control" [(ngModel)]="entity.nameFr" />
    </div>

    <div class="form-group">
      <label>{{'Name' | translate}} PT</label>
      <input class="form-control" [(ngModel)]="entity.namePt" />
    </div>

    <div class="form-group">
      <label>{{'Description' | translate}}</label>
      <textarea class="form-control" [(ngModel)]="entity.description"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Description' | translate}} BE</label>
      <textarea class="form-control" [(ngModel)]="entity.descriptionBe"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Description' | translate}} EN</label>
      <textarea class="form-control" [(ngModel)]="entity.descriptionEn"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Description' | translate}} DE</label>
      <textarea class="form-control" [(ngModel)]="entity.descriptionDe"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Description' | translate}} FR</label>
      <textarea class="form-control" [(ngModel)]="entity.descriptionFr"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Description' | translate}} PT</label>
      <textarea class="form-control" [(ngModel)]="entity.descriptionPt"></textarea>
    </div>

    <div class="form-group">
      <label>{{'Tags' | translate}}</label>
      <app-tag-input
        [suggestions]="availableTags"
        [(ngModel)]="entity.tags"
        (tagCreated)="onTagCreated($event)"
      ></app-tag-input>
    </div>


  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>
